import { Component, OnInit } from '@angular/core';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-cart-location-button',
    templateUrl: './cart-location-button.shared.component.html',
    styleUrls: ['./cart-location-button.shared.component.scss']
})
export class CartLocationButtonComponent implements OnInit {
    public locationName$: Observable<string>;
    public collectionTypeLabel$: Observable<string>;

    constructor(
        public controllers: Controllers,
        public routeService: Services.RouteService,
        public locationDetailsService: Services.LocationDetailsService,
    ) { }

    ngOnInit(): void {
        this.locationName$ = this.controllers.cart.cartLocationFriendlyName$();
        this.collectionTypeLabel$ = this.controllers.cart.getCartCollectionType$();
    }

    public onLocationClick($event: Event): void {
        this.controllers.locations.openCartLocationOpenHoursModal();
    }

}
